import { apiRequestToken } from '../Utilidades/apiRequest';
export const getPantallas = async () => {
    return apiRequestToken({
        endpoint: 'pantallas',
        method: 'GET',
    })
};